export const cloneDeepGridGroup = (group: GridGroup): GridGroup => {
    if (!group) return group

    return {
        ...group,
        items: group?.items?.map(item => cloneDeepGridItem(item))
    }
}

export const cloneDeepGridItem = (item: GridItem): GridItem => {
    if (!item) return item

    return {
        ...item,
        alarms: cloneDeepAlarmsProps(item.alarms)
    }
}

export const cloneDeepAlarmsProps = (props: AlarmsProps): AlarmsProps => {
    if (!props) return props

    return {
        configured: {
            background: props.configured?.background,
            iconColor: props.configured?.iconColor,
            icon: props.configured?.icon
        },
        warning: {
            background: props.warning?.background,
            iconColor: props.warning?.iconColor,
            icon: props.warning?.icon,
            blink: props.warning?.blink
        },
        critical: {
            background: props.critical?.background,
            iconColor: props.critical?.iconColor,
            icon: props.critical?.icon,
            blink: props.critical?.blink
        },
        notMapped: {
            background: props.notMapped?.background,
            iconColor: props.notMapped?.iconColor,
            icon: props.notMapped?.icon
        }
    }
}

export const cloneDeepGridEditorGroup = (group: GridEditorGroup): GridEditorGroup => {
    if (!group) return group

    return {
        ...group,
        channels: group.channels?.map(channel => cloneDeepGridEditorChannel(channel))
    }
}

export const cloneDeepGridEditorChannel = (channel: GridEditorChannelOption): GridEditorChannelOption => {
    if (!channel) return channel

    return {
        ...channel,
        alarms: cloneDeepAlarmsProps(channel.alarms)
    }
}
